import type { FunctionComponent } from 'react';

import { SparkleIcon } from '@trello/nachos/icons/sparkle';

import styles from './ComingSoonSection.less';

export const ComingSoonSection: FunctionComponent = () => {
  return (
    <div className={styles.section}>
      <SparkleIcon /> Coming soon!
      <div className={styles.tacoImage}></div>
    </div>
  );
};
